import { isB2BView } from './isB2BView'
import { isBuyerTokenMode } from './isBuyerTokenMode'
import { isBuyerView } from './isBuyerView'
import { isStaffTokenModeInBuyerView } from './isStaffTokenModeInBuyerView'

export const getAuthMode = () => {
  const buyerView = isBuyerView()
  const buyerTokenMode = isBuyerTokenMode()
  const staffTokenModeInBuyerView = isStaffTokenModeInBuyerView()
  const b2bView = isB2BView()

  return {
    buyerView,
    buyerTokenMode,
    staffTokenModeInBuyerView,
    b2bView,
    isBackOfficeTokenMode: b2bView || staffTokenModeInBuyerView,
  }
}
